import { MapDataAddress } from '@/types/map-data';

export default function normalizeAddress(val: MapDataAddress) {
    return (
			(val.Улица ? val.Улица + ', ' : '') +
			(val.Дом ? val.Дом + ', ' : '') +
			(val.Офис ? val.Офис + ', ' : '') +
			(val.Индекс ? val.Индекс : '')
    ).trim().replace(/^\,|\,$/gm, '')
}